<template>
  <v-radio-group
    :class="compGroupClass"
    v-model="elValue"
    :row="inline"
    :required="required"
    v-validate="validateRules"
    :data-vv-name="validateName"
    :error-messages="errorMessages"
    :data-vv-validate-on="'change'"
    hide-details="auto"
  >
    <v-radio
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :class="compClass"
      :readonly="readonly || item.readonly"
    >
      <template slot="label">
        <div class="text-inline my-1">
          <span :class="item.labelClass">{{ item.label }}</span>
          <el-tooltip v-if="item.tooltip" :tooltip="item.tooltip" />
        </div>
      </template>
    </v-radio>
  </v-radio-group>
</template>

<script>
export default {
  name: 'ElRadioGroup',
  props: {
    classP: String,
    items: Array,
    value: [Object, Boolean, String, Number],
    disabled: Boolean,
    readonly: Boolean,
    labelGrey: Boolean,
    required: Boolean,
    need: Boolean,
    label: { type: String, default: 'radio' },
    inline: { type: Boolean, default: false },
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compGroupClass() {
      return this.readonly ? 'radio-readonly' : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass}`
    },
    validateName() {
      return this.label
    },
    validateMessages() {
      return {
        'field is required': this.$t('Laukas privalomas'),
      }
    },
    validateRules() {
      let rule = ''
      rule = this.required ? 'required' : ''
      return rule
    },
    errorMessages() {
      const messages = this.errors.collect(this.validateName)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find(item =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },
    labelClass() {
      return this.labelGrey ? 'label-grey' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.label-grey {
  color: rgba(0, 0, 0, 0.38);
}
</style>
